import * as React from "react";
import {
  Button,
  Create,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  required,
  useRedirect,
} from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";

const OutletCreateToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="warning"
        label="Annuler"
        size="large"
        onClick={() => redirect("list", "outlets")}
        sx={{ ml: 2, pl: 4 }}
      >
        <CancelIcon />
      </Button>
    </Toolbar>
  );
};

export const OutletCreate: React.FC = () => (
  <Create resource="outlets" redirect="list" title="Créer un nouveau exutoire">
    <SimpleForm toolbar={<OutletCreateToolbar />}>
      <TextInput
        source="internalCode"
        label="Code interne"
        placeholder="Entrez le code interne de l'exutoire"
        validate={[required("Le code interne est requis")]}
      />
      <TextInput
        source="name"
        label="Nom de l'exutoire"
        placeholder="Entrez le nom de l'exutoire"
        validate={[required("Le nom de l'exutoire est requis")]}
      />
      <TextInput
        source="address"
        label="Adresse"
        placeholder="Entrez l'adresse de l'exutoire"
        validate={[required("L'adresse est requise")]}
      />
      <TextInput
        source="email"
        label="Email"
        placeholder="Entrez l'email de l'exutoire"
        validate={[required("L'email est requis")]}
      />
    </SimpleForm>
  </Create>
);
